// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import promise from 'es6-promise'
promise.polyfill()
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use({router})

import VueDND from 'awe-dnd'
import iView from 'iview';
import '../my-theme/color.less'


import "../plugins/zTree/js/jquery.ztree.core.min.js";
import "../plugins/zTree/js/jquery.ztree.excheck.min.js";
Vue.use(iView);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
Vue.use(VueDND,VueAwesomeSwiper)
Vue.config.productionTip = false;
Vue.prototype.debounce = (func, wait) => {
  let timeout = '';
  return (v) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(v);
    }, wait);
  }
};

Vue.component('r-select', {
  render: function (createElement) {
    var self = this
    return createElement('select', {
      domProps: {
        value: self.level
      },
      style: {
        width: '120px'
      },
      on: {
        change: function (event) {
          self.$emit('rselectLevel', event.target.value, self.row)
        }
      }
    }, self.items.map(function (item) {
      return createElement('option', {
        domProps: {
          value: item.value
        },
      }, item.label)
    }))
  },
  props: {
    level: {
      type: String,
      default: '1'
    },
    items: {
      type: Array,
      default: []
    },
    row: {
      type: Object,
      default: {}
    }
  },

});
router.beforeEach((to, from, next) => {
  setTimeout(() => {
    window._hmt = _hmt; // 修改为window 全局变量
      var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?b7c4a93106c8c7b0d77efc8652f95820";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }, 0);
    next();
  })

/* eslint-disable no-new */
new Vue({
  //mode: 'history',   //链接的方式用"/"的方式，前后台都需要设置才可以（用接口时）
  el: '#app',
  router,
  data: {
    wantUpdate: false
  },
  render: h => h(App), //引用element ui的时候用的
  template: '<App/>',
  components: {App}
})




// WEBPACK FOOTER //
// ./src/main.js